import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMediatempleComponent } from './simple-icons-mediatemple.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMediatempleComponent ],
    exports:      [ SimpleIconsMediatempleComponent ],
    bootstrap:    []
})
export class SimpleIconsMediatempleModule {}
